import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    userInfo: null,
    userRoleInfo: [],
    showMapLoader: false, // This can likely be removed. There is no setter called in codebase - and w/ a default of false, it never displays.
    showListCardLoader: false,
    treatmentCountQueryError: false,
    treatmentCount: 0,
    showGlobalLoader: false,
    actualTreatmentCount: 0,
    actualActivityCount: 0,
    activityCountQueryError: false,
    actualTreatmentCountQueryError: false,
    actualActivityCountQueryError: false,
    isTreatmentCountQuerying: false,
    isActivityCountQuerying: false,
    isActualTreatmentCountQuerying: false,
    isActualActivityCountQuerying: false,
    fundingDepartmentOptions: [],
    fundingAgencyOptions: [],
    fundingRegionOptions: [],
    fundingUnitOptions: [],
    fundingSubUnitOptions: [],
    fundingTribeOptions: [],
    fundingUnitTypeOptions: [],
    polygonListCount: 25,
    lineListCount: 25,
    pointListCount: 25,
    sortByValue: '',
    projectSortByValue: 'Name ASC',
    filterListOpen: false,
    wbsIDValues: [],
    congressDistValues: [],
    countyOptions: [],
    nameValueOptions: [],
    actionCategoryAssociations: [],
    statusOptions: [],
    alertMessageObj: {
        title: '',
        message: '',
        severity: '', // "error", "warning", "info", "success"
        child: null, // Used for arbitrary returns such as a Typography component
        callback: null, // Used for a callback function to be executed after the alert is closed
    },
    showAlertPopup: false,
    filterActionsDisabled: false,
};

export const globalContextSlice = createSlice({
    name: 'globalContext',
    initialState,
    reducers: {
        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },
        setUserRoleInfo: (state, action) => {
            state.userRoleInfo = action.payload;
        },
        setShowMapLoader: (state, action) => {
            //
            state.showMapLoader = action.payload;
        },
        setShowListCardLoader: (state, action) => {
            //
            state.showListCardLoader = action.payload;
        },
        setTreatmentCountQueryError: (state, action) => {
            state.treatmentCountQueryError = action.payload;
        },
        setTreatmentCount: (state, action) => {
            state.treatmentCount = action.payload;
        },
        setShowGlobalLoader: (state, action) => {
            state.showGlobalLoader = action.payload;
        },
        setActivityCount: (state, action) => {
            state.activityCount = action.payload;
        },
        setActualTreatmentCount: (state, action) => {
            state.actualTreatmentCount = action.payload;
        },
        setActualActivityCount: (state, action) => {
            state.actualActivityCount = action.payload;
        },
        setActivityCountQueryError: (state, action) => {
            state.activityCountQueryError = action.payload;
        },
        setActualTreatmentCountQueryError: (state, action) => {
            state.actualTreatmentCountQueryError = action.payload;
        },
        setActualActivityCountQueryError: (state, action) => {
            state.actualActivityCountQueryError = action.payload;
        },
        setIsTreatmentCountQuerying: (state, action) => {
            state.isTreatmentCountQuerying = action.payload;
        },
        setIsActivityCountQuerying: (state, action) => {
            state.isActivityCountQuerying = action.payload;
        },
        setIsActualTreatmentCountQuerying: (state, action) => {
            state.isActualTreatmentCountQuerying = action.payload;
        },
        setIsActualActivityCountQuerying: (state, action) => {
            state.isActualActivityCountQuerying = action.payload;
        },
        setFundingDepartmentOptions: (state, action) => {
            state.fundingDepartmentOptions = action.payload;
        },
        setFundingAgencyOptions: (state, action) => {
            state.fundingAgencyOptions = action.payload;
        },
        setFundingRegionOptions: (state, action) => {
            state.fundingRegionOptions = action.payload;
        },
        setFundingUnitOptions: (state, action) => {
            state.fundingUnitOptions = action.payload;
        },
        setFundingSubUnitOptions: (state, action) => {
            state.fundingSubUnitOptions = action.payload;
        },
        setFundingTribeOptions: (state, action) => {
            state.fundingTribeOptions = action.payload;
        },
        setFundingUnitTypeOptions: (state, action) => {
            state.fundingUnitTypeOptions = action.payload;
        },
        setPolygonListCount: (state, action) => {
            state.polygonListCount = action.payload;
        },
        setLineListCount: (state, action) => {
            state.lineListCount = action.payload;
        },
        setPointListCount: (state, action) => {
            state.pointListCount = action.payload;
        },
        setSortByValue: (state, action) => {
            state.sortByValue = action.payload;
        },
        setProjectSortByValue: (state, action) => {
            state.projectSortByValue = action.payload;
        },
        setFilterListOpen: (state, action) => {
            state.filterListOpen = action.payload;
        },
        setWbsIDValues: (state, action) => {
            state.wbsIDValues = action.payload;
        },
        setCongressDistValues: (state, action) => {
            state.congressDistValues = action.payload;
        },
        setCountyOptions: (state, action) => {
            state.countyOptions = action.payload;
        },
        setNameValueOptions: (state, action) => {
            state.nameValueOptions = action.payload;
        },
        setActionCategoryAssociations: (state, action) => {
            state.actionCategoryAssociations = action.payload;
        },
        setStatusOptions: (state, action) => {
            state.statusOptions = action.payload;
        },
        setAlertMessageObj: (state, action) => {
            state.alertMessageObj = action.payload;
            state.showAlertPopup = action.payload.severity && action.payload.severity !== '';
        },
        setFilterActionsDisabled: (state, action) => {
            state.filterActionsDisabled = action.payload;
        },
    },
});

export const {
    setShowMapLoader,
    setShowGlobalLoader,
    setShowListCardLoader,
    setStatusOptions,
    setTreatmentQueryError,
    setProjectQueryError,
    setActivityQueryError,
    setUserInfo,
    setUserRoleInfo,
    setActualTreatmentQueryError,
    setActualActivityQueryError,
    setTreatmentCount,
    setActivityCount,
    setActualTreatmentCount,
    setActualActivityCount,
    setTreatmentCountQueryError,
    setActivityCountQueryError,
    setActualTreatmentCountQueryError,
    setActualActivityCountQueryError,
    setIsTreatmentCountQuerying,
    setIsActivityCountQuerying,
    setIsActualTreatmentCountQuerying,
    setIsActualActivityCountQuerying,
    setFundingDepartmentOptions,
    setFundingAgencyOptions,
    setFundingRegionOptions,
    setFundingUnitOptions,
    setFundingSubUnitOptions,
    setFundingTribeOptions,
    setFundingUnitTypeOptions,
    setPolygonListCount,
    setLineListCount,
    setPointListCount,
    setSortByValue,
    setProjectSortByValue,
    setFilterListOpen,
    setWbsIDValues,
    setCongressDistValues,
    setCountyOptions,
    setNameValueOptions,
    setActionCategoryAssociations,
    setAlertMessageObj,
    setFilterActionsDisabled,
} = globalContextSlice.actions;

export default globalContextSlice.reducer;
